// Lightweight Google Analytics 4 wrapper.
// Loads gtag.js lazily, AFTER explicit user consent.
// Stores consent in localStorage so the decision persists across sessions.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
const CONSENT_KEY = "bgb_ga_consent"; // values: "granted" | "denied" | (absent)
const SCRIPT_ID = "ga-script";

let scriptLoaded = false;

function gtag(...args) {
  // eslint-disable-next-line no-undef
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line no-undef
  window.dataLayer.push(args);
}

function loadGtagScript() {
  if (scriptLoaded || !GA_ID) return;
  if (document.getElementById(SCRIPT_ID)) {
    scriptLoaded = true;
    return;
  }
  const s = document.createElement("script");
  s.id = SCRIPT_ID;
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  scriptLoaded = true;

  gtag("js", new Date());
  gtag("config", GA_ID, {
    anonymize_ip: true,
    send_page_view: false, // we send explicitly on route changes
  });
}

export function hasConsentDecision() {
  return typeof window !== "undefined" && !!localStorage.getItem(CONSENT_KEY);
}

export function getConsent() {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(CONSENT_KEY); // "granted" | "denied" | null
}

export function grantConsent() {
  localStorage.setItem(CONSENT_KEY, "granted");
  loadGtagScript();
}

export function denyConsent() {
  localStorage.setItem(CONSENT_KEY, "denied");
}

export function resetConsent() {
  localStorage.removeItem(CONSENT_KEY);
}

export function isAnalyticsActive() {
  return getConsent() === "granted" && !!GA_ID;
}

export function trackPageView(path, title) {
  if (!isAnalyticsActive()) return;
  loadGtagScript();
  gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  if (!isAnalyticsActive()) return;
  loadGtagScript();
  gtag("event", name, params);
}
